export default [
    { name: 'examination', path: '/examination', component: () => import('@/views/examination/examination.vue'), },
    // { name: 'examination', path: '/', component: () => import('@/views/examination/test.vue'), },
    { name:'examinationAnswerResult', path: '/examinationAnswerResult', component: () => import('@/views/examination/examinationAnswerResult') },
    // { name: 'examinationAnswerResult', path: '/examinationAnswerResult', component: () => import('@/views/examination/examinationAnswerResult')},

]